import * as actionTypes from '../constants/actionTypes';
export function reloadImages(currentScreenID) {
    return {
        type: actionTypes.RELOAD_IMAGES,
        currentScreenID: currentScreenID,
    };
}
export function imageLoadingStart(id) {
    return {
        type: actionTypes.IMAGE_LOADING_START,
        id: id,
    };
}
